<script setup>
import { computed, provide } from 'vue'
import { buildVisibleTree, componentMap } from '@/Components/Navigation'

const props = defineProps({
  // Note: for now we are assuming all items belong to the left section, when
  // the right side is added back, we should drop the "items" prop and add
  // "left" and "right" props.
  items: {
    default: {},
  },
})

const computedItems = computed(() => {
  if (Array.isArray(props.items)) {
    return props.items
  }

  return buildVisibleTree(props.items, 'desktop', 'left')
})

provide('viewport', 'desktop')
</script>

<template>
  <div class="flex justify-between items-center">
    <!-- Left Section -->
    <div class="flex flex-1 items-center md:flex-wrap gap-4">
      <Component
        v-for="item in computedItems"
        :key="item.id"
        :is="componentMap[item.component]"
        v-bind="item"
      />
    </div>

    <!-- Right section should go here -->
  </div>
</template>
